import { render, staticRenderFns } from "./IndexTask.vue?vue&type=template&id=1f5be1c2&"
import script from "./IndexTask.vue?vue&type=script&lang=js&"
export * from "./IndexTask.vue?vue&type=script&lang=js&"
import style0 from "./IndexTask.vue?vue&type=style&index=0&id=1f5be1c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports